export default __webpack_public_path__ + "static/media/logo-clube-das-flores.36bafffe.png";